import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import InputMask from "react-input-mask";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

import api from "../../services/api";
import * as S from "./styled";
import { useAuth } from "../../context/auth";
import Template from "../../template";

function Atividades(props) {
  const { user } = useAuth();
  const { id } = props.match.params;

  // Estados principais
  const [atividades, setAtividades] = useState([]);
  const [todasAtividades, setTodasAtividades] = useState([]);
  const [turma, setNomeTurma] = useState("");

  // Estados do formulário
  const [nomeAtividade, setNomeAtividade] = useState("");
  const [generoAtividade, setGeneroAtividade] = useState("");
  /*
    Dois modos INDEPENDENTES, cada um com seu próprio campo:

      - `modoCorrecaoTema`  -> temas.modo_correcao
        O modo da atividade em si. É o que vale antes de ela entrar em qualquer
        turma e o que as próximas turmas herdam ao recebê-la.

      - `modoCorrecaoTurma` -> redacoes_classe.modo_correcao
        O modo dela NESTA turma. Sobrepõe o do tema aqui e não afeta as outras
        turmas que já têm a mesma atividade.

    Mexer num não mexe no outro. Ambos nascem em "humano": o fluxo novo tem que
    ser escolhido de propósito.
  */
  const [modoCorrecaoTema, setModoCorrecaoTema] = useState("humano");
  const [modoCorrecaoTurma, setModoCorrecaoTurma] = useState("humano");
  const [observacaoAtividade, setObservacaoAtividade] = useState("");
  const [numeroAula, setNumeroAula] = useState("");
  const [dataEntrega, setDataEntrega] = useState("");
  const [horaEntrega, setHoraEntrega] = useState("");
  const [link, setLink] = useState("");
  const [arquivo, setArquivo] = useState("");
  const [descricao, setDescricao] = useState("");

  // Estados para controle de fluxo
  const [entrega, setEntrega] = useState(false);
  const [atrelarParaTurma, setAtrelarParaTurma] = useState(0);
  const [idAtividade, setIdAtividade] = useState(0);
  const [idAtividadeRedacao, setIdAtividadeRedacao] = useState(0);

  // Estados para filtros
  const [filtroTipo, setFiltroTipo] = useState("");
  const [buscaNome, setBuscaNome] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("");
  /*
    Um filtro para cada modo, porque são independentes: dá para procurar as
    atividades que estão IA + Humano NESTA turma, ou as que têm IA + Humano como
    padrão da atividade — e combinar os dois para achar onde eles divergem.
  */
  const [filtroCorrecaoTurma, setFiltroCorrecaoTurma] = useState("");
  const [filtroCorrecaoAtividade, setFiltroCorrecaoAtividade] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  // Estados para paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Estados para modais
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showEditDate, setShowEditDate] = useState(false);
  const [showMaterial, setShowMaterial] = useState(false);
  const [showBulkAdd, setShowBulkAdd] = useState(false);

  // Estados para seleção múltipla
  const [selectedAtividades, setSelectedAtividades] = useState([]);
  const [dataLimite, setDataLimite] = useState("");
  const [horaLimite, setHoraLimite] = useState("");
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const [modalItemsPerPage] = useState(10);

  // Estados para filtros do modal
  const [modalFiltroTipo, setModalFiltroTipo] = useState("");
  const [modalBuscaNome, setModalBuscaNome] = useState("");
  const [modalShowDropdown, setModalShowDropdown] = useState(false);
  const [modalFilteredSuggestions, setModalFilteredSuggestions] = useState([]);

  // Função para gerar sugestões de nomes
  const gerarSugestoes = (valor) => {
    if (!valor.trim()) {
      setFilteredSuggestions([]);
      setShowDropdown(false);
      return;
    }

    const sugestoes = todasAtividades
      .filter(atividade => 
        atividade.nome.toLowerCase().includes(valor.toLowerCase())
      )
      .map(atividade => atividade.nome)
      .filter((nome, index, self) => self.indexOf(nome) === index) // Remove duplicatas
      .slice(0, 5); // Limita a 5 sugestões

    setFilteredSuggestions(sugestoes);
    setShowDropdown(sugestoes.length > 0);
  };

  // Função para aplicar filtros e paginação
  const aplicarFiltros = (dados = todasAtividades) => {
    let atividadesFiltradas = dados;

    // Filtro por tipo
    if (filtroTipo) {
      atividadesFiltradas = atividadesFiltradas.filter(
        (atividade) => atividade.genero === filtroTipo
      );
    }

    // Filtro por nome
    if (buscaNome) {
      atividadesFiltradas = atividadesFiltradas.filter((atividade) =>
        atividade.nome.toLowerCase().includes(buscaNome.toLowerCase())
      );
    }

    // Filtro por status
    if (filtroStatus) {
      if (filtroStatus === "em_uso") {
        atividadesFiltradas = atividadesFiltradas.filter(
          (atividade) => atividade.classe_id == id
        );
      } else if (filtroStatus === "disponivel") {
        atividadesFiltradas = atividadesFiltradas.filter(
          (atividade) => atividade.classe_id != id
        );
      }
    }

    /*
      Correção nesta turma: só faz sentido para atividades atreladas, então as que
      não estão na turma ficam de fora quando este filtro é usado.
    */
    if (filtroCorrecaoTurma) {
      atividadesFiltradas = atividadesFiltradas.filter((atividade) => {
        if (!atividade.id_atividade) return false;
        const modo = atividade.modo_correcao === "ia_humano" ? "ia_humano" : "humano";
        return modo === filtroCorrecaoTurma;
      });
    }

    // Correção da atividade em si: vale para todas, atreladas ou não
    if (filtroCorrecaoAtividade) {
      atividadesFiltradas = atividadesFiltradas.filter((atividade) => {
        const modo = atividade.modo_correcao_tema === "ia_humano" ? "ia_humano" : "humano";
        return modo === filtroCorrecaoAtividade;
      });
    }

    // Aplicar paginação
    const totalItens = atividadesFiltradas.length;
    const totalPaginas = Math.ceil(totalItens / itemsPerPage);
    const indiceInicial = (currentPage - 1) * itemsPerPage;
    const indiceFinal = indiceInicial + itemsPerPage;
    const atividadesPaginadas = atividadesFiltradas.slice(indiceInicial, indiceFinal);

    setAtividades(atividadesPaginadas);
    setTotalItems(totalItens);
    setTotalPages(totalPaginas);
  };

  // Função para limpar filtros
  const limparFiltros = () => {
    setFiltroTipo("");
    setBuscaNome("");
    setFiltroStatus("");
    setFiltroCorrecaoTurma("");
    setFiltroCorrecaoAtividade("");
    setCurrentPage(1);
    setShowDropdown(false);
    setFilteredSuggestions([]);
  };

  // Função para lidar com mudanças no campo de busca
  const handleBuscaNomeChange = (e) => {
    const valor = e.target.value;
    setBuscaNome(valor);
    gerarSugestoes(valor);
  };

  // Função para selecionar uma sugestão
  const selecionarSugestao = (sugestao) => {
    setBuscaNome(sugestao);
    setShowDropdown(false);
    setFilteredSuggestions([]);
  };

  // Funções de paginação
  const irParaPagina = (pagina) => {
    setCurrentPage(pagina);
  };

  const paginaAnterior = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const proximaPagina = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Função para limpar campos do formulário
  const limparCampos = () => {
    setNomeAtividade("");
    setGeneroAtividade("");
    setModoCorrecaoTema("humano");
    setModoCorrecaoTurma("humano");
    setObservacaoAtividade("");
    setNumeroAula("");
    setDataEntrega("");
    setHoraEntrega("");
    setLink("");
    setArquivo("");
    setDescricao("");
    setEntrega(false);
    setAtrelarParaTurma(0);
    setIdAtividade(0);
    setIdAtividadeRedacao(0);
  };

  // Função para fechar modais
  const handleCloseAdd = () => {
    setShowAdd(false);
    limparCampos();
  };

  const handleCloseEdit = () => {
    setShowEdit(false);
    limparCampos();
  };

  const handleCloseEditDate = () => {
    setShowEditDate(false);
    limparCampos();
  };

  const handleCloseMaterial = () => {
    setShowMaterial(false);
    setArquivo("");
    setDescricao("");
  };

  const handleCloseBulkAdd = () => {
    setShowBulkAdd(false);
    setSelectedAtividades([]);
    setDataLimite("");
    setHoraLimite("");
    setModalCurrentPage(1);
    limparFiltrosModal();
  };

  // Função para gerar sugestões de nomes no modal
  const gerarSugestoesModal = (valor) => {
    if (!valor.trim()) {
      setModalFilteredSuggestions([]);
      setModalShowDropdown(false);
      return;
    }

    const sugestoes = todasAtividades
      .filter(atividade => 
        atividade.nome.toLowerCase().includes(valor.toLowerCase())
      )
      .map(atividade => atividade.nome)
      .filter((nome, index, self) => self.indexOf(nome) === index) // Remove duplicatas
      .slice(0, 5); // Limita a 5 sugestões

    setModalFilteredSuggestions(sugestoes);
    setModalShowDropdown(sugestoes.length > 0);
  };

  // Função para aplicar filtros e paginação no modal
  const getModalAtividades = () => {
    let atividadesFiltradas = todasAtividades;

    // Filtro por tipo
    if (modalFiltroTipo) {
      atividadesFiltradas = atividadesFiltradas.filter(
        (atividade) => atividade.genero === modalFiltroTipo
      );
    }

    // Filtro por nome
    if (modalBuscaNome) {
      atividadesFiltradas = atividadesFiltradas.filter((atividade) =>
        atividade.nome.toLowerCase().includes(modalBuscaNome.toLowerCase())
      );
    }

    const totalItens = atividadesFiltradas.length;
    const totalPaginas = Math.ceil(totalItens / modalItemsPerPage);
    const indiceInicial = (modalCurrentPage - 1) * modalItemsPerPage;
    const indiceFinal = indiceInicial + modalItemsPerPage;
    const atividadesPaginadas = atividadesFiltradas.slice(indiceInicial, indiceFinal);
    
    return {
      atividades: atividadesPaginadas,
      totalPaginas,
      totalItens
    };
  };

  // Função para lidar com mudanças no campo de busca do modal
  const handleModalBuscaNomeChange = (e) => {
    const valor = e.target.value;
    setModalBuscaNome(valor);
    setModalCurrentPage(1); // Reset para primeira página ao filtrar
    gerarSugestoesModal(valor);
  };

  // Função para limpar filtros do modal
  const limparFiltrosModal = () => {
    setModalFiltroTipo("");
    setModalBuscaNome("");
    setModalCurrentPage(1);
    setModalShowDropdown(false);
    setModalFilteredSuggestions([]);
  };

  // Função para alternar seleção de atividade
  const toggleAtividadeSelection = (atividade) => {
    setSelectedAtividades(prev => {
      const isSelected = prev.some(item => item.id === atividade.id);
      if (isSelected) {
        return prev.filter(item => item.id !== atividade.id);
      } else {
        return [...prev, atividade];
      }
    });
  };

  // Função para enviar atividades em lote
  const enviarLoteAtividades = async () => {
    if (selectedAtividades.length === 0) {
      toast.error("Selecione pelo menos uma atividade");
      return;
    }

    if (!dataLimite || !horaLimite) {
      toast.error("Preencha a data e hora limite");
      return;
    }

    try {
      const atividades = selectedAtividades.map(atividade => ({
        tema_id: atividade.id,
        atividade: atividade.nome
      }));

      const data = {
        atividades,
        dia_limite: dataLimite,
        hora_limite: horaLimite,
        classe_id: parseInt(id)
      };

      const response = await api.post("/atividades", data);
      
      if (response.status === 200) {
         toast.success(response.data.message);
         handleCloseBulkAdd();
         getAtividades();
       }
    } catch (error) {
      console.error("Erro ao enviar lote de atividades:", error);
      toast.error(error.response?.data?.message || "Erro ao cadastrar atividades");
    }
  };

  // Cadastrar atividade
  const cadastrarAtividade = async () => {
    if (!nomeAtividade || !generoAtividade || !numeroAula) {
      toast.error("Preencha todos os campos obrigatórios!");
      return;
    }

    try {
      const data = {
        nome: nomeAtividade,
        genero: generoAtividade,
        aula: numeroAula,
        tipo: 1,
        descricao: observacaoAtividade,
        arquivo: link,
        // modo próprio da atividade; o vínculo com a turma herda daqui
        modo_correcao: modoCorrecaoTema,
      };

      const retorno = await api.post("/cadastrarAtividade", data);

      if (retorno.data.id) {
        setAtrelarParaTurma(retorno.data.id);
        toast.success("Atividade cadastrada com sucesso!");
      } else {
        toast.error("Erro ao cadastrar atividade!");
      }
    } catch (err) {
      toast.error("Erro ao cadastrar atividade!");
    }
  };

  // Editar atividade
  const editarAtividade = async () => {
    if (!nomeAtividade || !generoAtividade || !numeroAula) {
      toast.error("Preencha todos os campos obrigatórios!");
      return;
    }

    try {
      const data = {
        nome: nomeAtividade,
        genero: generoAtividade,
        aula: numeroAula,
        tipo: 1,
        descricao: observacaoAtividade,
        arquivo: link,
        // vai só para `temas`: é o modo da atividade, não o desta turma
        modo_correcao: modoCorrecaoTema,
        id: idAtividade,
      };

      await api.put("/editarAtividade", data);

      /*
        O modo de correção vai numa chamada separada porque é do vínculo com ESTA
        turma, enquanto /editarAtividade altera o tema e vale para todas. Só existe
        vínculo se a atividade já foi atrelada à turma.
      */
      if (idAtividadeRedacao) {
        await api.put(`/atividade-turma/${idAtividadeRedacao}/modo-correcao`, {
          modo_correcao: modoCorrecaoTurma,
        });
      }

      handleCloseEdit();
      getAtividades();
      toast.success("Atividade editada com sucesso!");
    } catch (err) {
      toast.error("Erro ao editar atividade!");
    }
  };

  // Editar data da atividade
  const editarDataAtividade = async () => {
    if (!horaEntrega || !dataEntrega) {
      toast.error("Uma nova hora e data devem ser preenchidas");
      return;
    }

    try {
      const data = {
        hora: horaEntrega,
        entrega: dataEntrega.split("/").reverse().join("-"),
        id: idAtividadeRedacao,
      };

      await api.put("/editarDataAtividade", data);
      handleCloseEditDate();
      getAtividades();
      toast.success("Entrega da atividade editada com sucesso!");
    } catch (err) {
      toast.error("Erro ao editar atividade!");
    }
  };

  // Carregar tema para edição
  const carregarTema = async (id_tema) => {
    try {
      const response = await api.get(`/carregarTema/${id_tema}`);
      const tema = response.data[0];

      setNomeAtividade(tema.nome);
      setGeneroAtividade(tema.genero);
      setNumeroAula(tema.aula);
      setObservacaoAtividade(tema.descricao);
      setLink(tema.arquivo);
      setIdAtividade(id_tema);
    } catch (err) {
      toast.error("Erro ao carregar dados da atividade!");
    }
  };

  // Upload de arquivo
  async function sendFile(e) {
    const data = new FormData();

    if (e.target.files[0]) {
      data.append("arquivo", e.target.files[0]);
      try {
        const response = await api.post("arquivoUpload", data);
        setLink(`/${response.data.arquivo}`);
        toast.success("Arquivo enviado com sucesso!");
      } catch (err) {
        toast.error("Erro ao enviar arquivo!");
      }
    }
  }

  // Atrelar atividade à turma
  async function adicionarAtividadeTurma() {
    if (!dataEntrega || !horaEntrega) {
      toast.error("Data e hora de entrega são obrigatórias!");
      return;
    }

    try {
      const dataAtividade = {
        classe_id: id,
        entrega: dataEntrega.split("/").reverse().join("-"),
        hora: horaEntrega,
        tema_id: atrelarParaTurma,
        atividade: nomeAtividade,
        modo_correcao: modoCorrecaoTurma,
      };

      await api.post("/adicionarAtividade", dataAtividade);
      handleCloseAdd();
      getAtividades();
      toast.success("Atividade cadastrada para a turma com sucesso!");
    } catch (err) {
      toast.error("Erro ao adicionar atividade à turma!");
    }
  }

  // Carregar atividades
  async function getAtividades() {
    try {
      setLoading(true);
      
      // Buscar dados da turma e temas relacionados
      let response = await api.get(`/mostrar-temas/${id}`);
      
      // Buscar todos os temas com dados completos
      let temasCompletos = await api.get('/pegarTemasGeral');
      
      console.log('=== DADOS DA API ===');
      console.log('Temas da turma:', response.data.temas);
      console.log('Existentes:', response.data.existentes);
      console.log('Temas completos:', temasCompletos.data);

      // Mapear todos os temas e adicionar informações dos existentes quando disponível
      const itens = response.data.temas.map((tema) => {
        const existente = response.data.existentes.find(ex => ex.id === tema.id);
        const temaCompleto = temasCompletos.data.find(tc => tc.id === tema.id);
        
        if (existente) {
          // Se o tema já existe na turma, usar dados do existente para arquivo/descrição
          const itemCompleto = {
            ...tema,
            classe_id: existente.classe_id,
            entrega: existente.entrega,
            hora: existente.hora,
            arquivo: existente.arquivo || (temaCompleto ? temaCompleto.arquivo : null),
            id_atividade: existente.id_atividade,
            // vinculada: o modo desta turma sobrepõe o do tema, mas os dois são exibidos
            modo_correcao: existente.modo_correcao || "humano",
            modo_correcao_tema:
              existente.modo_correcao_tema || tema.modo_correcao_tema || "humano",
            descricao: existente.descricao || (temaCompleto ? temaCompleto.descricao : null)
          };
          console.log('Item com existente:', itemCompleto);
          return itemCompleto;
        } else {
          // Se o tema não existe na turma, usar dados completos do tema
          const itemOriginal = {
            ...tema,
            arquivo: temaCompleto ? temaCompleto.arquivo : tema.arquivo,
            descricao: temaCompleto ? temaCompleto.descricao : tema.descricao,
            classe_id: null,
            entrega: null,
            hora: null,
            id_atividade: null,
            // sem vínculo: o único modo que existe é o do próprio tema
            modo_correcao: null,
            modo_correcao_tema:
              tema.modo_correcao_tema || (temaCompleto ? temaCompleto.modo_correcao : null) || "humano"
          };
          console.log('Item original:', itemOriginal);
          return itemOriginal;
        }
      });

      setNomeTurma(response.data.turma[0].nome);
      setTodasAtividades(itens);
    } catch (err) {
      toast.error("Erro ao carregar atividades!");
    } finally {
      setLoading(false);
    }
  }

  // Formatar data
  const formatarData = (dataTurma) => {
    if (dataTurma) {
      return dataTurma.split("-").reverse().join("/");
    }
    return "";
  };

  // Aplicar filtros quando mudarem
  useEffect(() => {
    aplicarFiltros();
  }, [filtroTipo, buscaNome, filtroStatus, filtroCorrecaoTurma, filtroCorrecaoAtividade, currentPage, itemsPerPage, todasAtividades]);

  useEffect(() => {
    getAtividades();
  }, []);

  return (
    <Template>
      <S.MainWrapper>
        <Container fluid className="pt-3 pb-4" style={{ maxWidth: '95%' }}>
          <Row>
            <Col sm={12}>
              {/* Header com estatísticas */}
              <div className="shadow-sm p-4 mb-4 bg-white rounded">
                <Row>
                  <Col md={8}>
                    <div className="d-flex align-items-center">
                      <div className="bg-primary text-white rounded-circle p-3 mr-3">
                        <i className="fas fa-tasks fa-2x"></i>
                      </div>
                      <div>
                        <h4 className="mb-1 font-weight-bold text-dark">
                          Atividades {turma && `- ${turma}`}
                        </h4>
                        <p className="mb-0 text-muted">
                          Gerencie as atividades da turma
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="text-center">
                      <div className="display-4 text-primary font-weight-bold">
                        {totalItems}
                      </div>
                      <small className="text-muted font-weight-bold">
                        {totalItems === 1 ? 'atividade encontrada' : 'atividades encontradas'}
                      </small>
                      {totalItems > 0 && (
                        <div className="mt-2">
                          <small className="text-info font-weight-bold">
                            Página {currentPage} de {totalPages}
                          </small>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>

              {/* Ações Rápidas */}
              {user.nivel === "a" && (
                <div className="shadow-sm p-3 mb-4 bg-white rounded">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 text-dark font-weight-bold">
                      <i className="fas fa-bolt text-warning mr-2"></i>
                      Ações Rápidas
                    </h5>
                    <div>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => setShowAdd(true)}
                        className="mr-2"
                      >
                        <i className="fas fa-plus mr-1"></i>
                        Adicionar Atividade
                      </Button>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => setShowBulkAdd(true)}
                        className="mr-2"
                      >
                        <i className="fas fa-list-check mr-1"></i>
                        Selecionar Temas para Vincular
                      </Button>
                      {turma && (
                        <Link
                          to={`/minhaclasse/${id}`}
                          className="btn btn-info btn-sm"
                        >
                          <i className="fas fa-arrow-left mr-1"></i>
                          Voltar para {turma}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Filtros e Busca */}
              <div className="shadow-sm p-4 mb-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0 text-dark font-weight-bold">
                    <i className="fas fa-filter text-primary mr-2"></i>
                    Filtros e Busca
                  </h5>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={limparFiltros}
                    className="d-flex align-items-center"
                  >
                    <i className="fas fa-times mr-1"></i>
                    Limpar Filtros
                  </Button>
                </div>

                <Row>
                  {/* Itens por página */}
                  <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-dark">
                        <i className="fas fa-list text-primary mr-1"></i>
                        Itens por Página
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          as="select"
                          value={itemsPerPage}
                          onChange={(e) => {
                            setItemsPerPage(parseInt(e.target.value));
                            setCurrentPage(1);
                          }}
                          className="form-control-lg"
                        >
                          <option value={5}>5 por página</option>
                          <option value={10}>10 por página</option>
                          <option value={15}>15 por página</option>
                          <option value={20}>20 por página</option>
                          <option value={25}>25 por página</option>
                          <option value={50}>50 por página</option>
                        </Form.Control>
                      </InputGroup>
                    </Form.Group>
                  </Col>

                  {/* Busca por nome */}
                  <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                    <Form.Group className="position-relative">
                      <Form.Label className="font-weight-bold text-dark">
                        <i className="fas fa-search text-primary mr-1"></i>
                        Buscar por Nome
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Digite o nome da atividade"
                          value={buscaNome}
                          onChange={(e) => {
                            handleBuscaNomeChange(e);
                            setCurrentPage(1);
                          }}
                          onFocus={() => gerarSugestoes(buscaNome)}
                          onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                          className="form-control-lg"
                        />
                        <InputGroup.Append>
                          <InputGroup.Text>
                            <i className="fas fa-search"></i>
                          </InputGroup.Text>
                        </InputGroup.Append>
                      </InputGroup>
                      {showDropdown && filteredSuggestions.length > 0 && (
                        <div 
                          className="position-absolute w-100 border border-top-0 rounded-bottom shadow-sm" 
                          style={{ 
                            zIndex: 1000, 
                            maxHeight: '200px', 
                            overflowY: 'auto', 
                            top: '100%',
                            backgroundColor: '#ffffff',
                            opacity: 1
                          }}
                        >
                          {filteredSuggestions.map((sugestao, index) => (
                             <div
                               key={index}
                               className="p-2 border-bottom text-dark"
                               style={{ 
                                 cursor: 'pointer', 
                                 color: '#333',
                                 backgroundColor: '#ffffff',
                                 opacity: 1
                               }}
                               onMouseDown={() => selecionarSugestao(sugestao)}
                               onMouseEnter={(e) => {
                                 e.target.style.backgroundColor = '#f8f9fa';
                                 e.target.style.color = '#333';
                                 e.target.style.opacity = '1';
                               }}
                               onMouseLeave={(e) => {
                                 e.target.style.backgroundColor = '#ffffff';
                                 e.target.style.color = '#333';
                                 e.target.style.opacity = '1';
                               }}
                             >
                               <i className="fas fa-file-alt mr-2 text-muted"></i>
                               <span style={{ color: '#333' }}>{sugestao}</span>
                             </div>
                           ))}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Filtro por tipo */}
                  <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-dark">
                        <i className="fas fa-tag text-primary mr-1"></i>
                        Filtrar por Tipo
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          as="select"
                          value={filtroTipo}
                          onChange={(e) => {
                            setFiltroTipo(e.target.value);
                            setCurrentPage(1);
                          }}
                          className="form-control-lg"
                        >
                          <option value="">Todos os Tipos</option>
                          <option value="Tema">Tema</option>
                          <option value="Tema Bônus">Tema Bônus</option>
                          <option value="Simulado">Simulado</option>
                        </Form.Control>
                      </InputGroup>
                    </Form.Group>
                  </Col>

                  {/* Filtro por status */}
                  <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-dark">
                        <i className="fas fa-check-circle text-primary mr-1"></i>
                        Filtrar por Status
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          as="select"
                          value={filtroStatus}
                          onChange={(e) => {
                            setFiltroStatus(e.target.value);
                            setCurrentPage(1);
                          }}
                          className="form-control-lg"
                        >
                          <option value="">Todos os Status</option>
                          <option value="em_uso">Em Uso</option>
                          <option value="disponivel">Disponível</option>
                        </Form.Control>
                      </InputGroup>
                    </Form.Group>
                  </Col>

                  {/* Correção nesta turma (vínculo) */}
                  <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-dark">
                        <i className="fas fa-robot text-primary mr-1"></i>
                        Correção nesta turma
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          as="select"
                          value={filtroCorrecaoTurma}
                          onChange={(e) => {
                            setFiltroCorrecaoTurma(e.target.value);
                            setCurrentPage(1);
                          }}
                          className="form-control-lg"
                        >
                          <option value="">Todas</option>
                          <option value="humano">Humano</option>
                          <option value="ia_humano">IA + Humano</option>
                        </Form.Control>
                      </InputGroup>
                      {filtroCorrecaoTurma && (
                        <small className="form-text text-muted">
                          Mostra só atividades que já estão nesta turma.
                        </small>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Correção da atividade em si (tema) */}
                  <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
                    <Form.Group>
                      <Form.Label className="font-weight-bold text-dark">
                        <i className="fas fa-robot text-primary mr-1"></i>
                        Correção da atividade
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          as="select"
                          value={filtroCorrecaoAtividade}
                          onChange={(e) => {
                            setFiltroCorrecaoAtividade(e.target.value);
                            setCurrentPage(1);
                          }}
                          className="form-control-lg"
                        >
                          <option value="">Todas</option>
                          <option value="humano">Humano</option>
                          <option value="ia_humano">IA + Humano</option>
                        </Form.Control>
                      </InputGroup>
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              {/* Lista de Atividades */}
              <div className="shadow-sm bg-white rounded">
                <div className="p-4 border-bottom">
                  <h5 className="mb-0 text-dark font-weight-bold">
                    <i className="fas fa-list text-primary mr-2"></i>
                    Lista de Atividades
                  </h5>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="bg-light">
                      <tr>
                        <th className="border-0 font-weight-bold text-dark">
                          <i className="fas fa-tag mr-1"></i>
                          Tipo
                        </th>
                        <th className="border-0 font-weight-bold text-dark">
                          <i className="fas fa-chalkboard-teacher mr-1"></i>
                          Aula
                        </th>
                        <th className="border-0 font-weight-bold text-dark">
                          <i className="fas fa-book mr-1"></i>
                          Tema
                        </th>
                        <th className="border-0 font-weight-bold text-dark">
                          <i className="fas fa-robot mr-1"></i>
                          Correção
                        </th>
                        <th className="border-0 font-weight-bold text-dark">
                          <i className="fas fa-calendar mr-1"></i>
                          Data de Entrega
                        </th>
                        <th className="border-0 font-weight-bold text-dark">
                          <i className="fas fa-file mr-1"></i>
                          Material
                        </th>
                        <th className="border-0 font-weight-bold text-dark">
                          <i className="fas fa-plus mr-1"></i>
                          Status
                        </th>
                        <th className="border-0 font-weight-bold text-dark text-center">
                          <i className="fas fa-cogs mr-1"></i>
                          Ações
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8" className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="sr-only">Carregando...</span>
                            </div>
                            <p className="mt-2 text-muted">Carregando atividades...</p>
                          </td>
                        </tr>
                      ) : atividades.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="text-center py-4">
                            <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                            <p className="text-muted mb-0">Nenhuma atividade encontrada</p>
                          </td>
                        </tr>
                      ) : (
                        atividades.map((atividade, idx) => (
                          <tr key={idx}>
                            <td>
                              <span className={`badge badge-${atividade.genero === 'Tema' ? 'primary' : atividade.genero === 'Tema Bônus' ? 'success' : 'warning'} p-2`}>
                                {atividade.genero}
                              </span>
                            </td>
                            <td className="font-weight-bold">{atividade.aula}</td>
                            <td>{atividade.nome}</td>
                            <td>
                              {/*
                                Os dois com o mesmo peso visual: são valores independentes
                                e ler só um leva a engano. Sem vínculo, o da turma não existe
                                e aparece como "—" em vez de sumir.
                              */}
                              <div className="mb-2">
                                <div className="text-muted font-weight-bold" style={{ fontSize: "10px", letterSpacing: "0.4px" }}>
                                  NESTA TURMA
                                </div>
                                {atividade.id_atividade ? (
                                  <span
                                    className={`badge badge-${atividade.modo_correcao === "ia_humano" ? "info" : "secondary"} p-2`}
                                    style={{ borderRadius: "12px", whiteSpace: "normal", fontSize: "12px" }}
                                  >
                                    {atividade.modo_correcao === "ia_humano" ? "IA + Humano" : "Humano"}
                                  </span>
                                ) : (
                                  <div className="text-muted" style={{ fontSize: "12px" }}>— não está nesta turma</div>
                                )}
                              </div>

                              <div>
                                <div className="text-muted font-weight-bold" style={{ fontSize: "10px", letterSpacing: "0.4px" }}>
                                  ATIVIDADE
                                </div>
                                <span
                                  className={`badge badge-${atividade.modo_correcao_tema === "ia_humano" ? "info" : "secondary"} p-2`}
                                  style={{ borderRadius: "12px", whiteSpace: "normal", fontSize: "12px" }}
                                >
                                  {atividade.modo_correcao_tema === "ia_humano" ? "IA + Humano" : "Humano"}
                                </span>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <span>
                                  {formatarData(atividade.entrega)} {atividade.hora}
                                </span>
                                {atividade.classe_id == id && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Editar data de entrega</Tooltip>}
                                  >
                                    <Button
                                      variant="link"
                                      size="sm"
                                      className="ml-2 p-0"
                                      onClick={() => {
                                        carregarTema(atividade.id);
                                        setIdAtividadeRedacao(atividade.id_atividade);
                                        setShowEditDate(true);
                                      }}
                                    >
                                      <i className="fas fa-edit text-primary"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )}
                              </div>
                            </td>
                            <td>
                              <Button
                                variant="outline-warning"
                                size="sm"
                                onClick={() => {
                                  setArquivo(atividade.arquivo);
                                  setDescricao(atividade.descricao);
                                  setShowMaterial(true);
                                  console.log('=== CLICOU NO BOTÃO MATERIAL ===');
                                  console.log('Todos os dados', atividade);
                                  console.log('Arquivo:', atividade.arquivo);
                                  console.log('Descrição:', atividade.descricao);
                                }}
                              >
                                <i className="fas fa-file-alt mr-1"></i>
                                Material
                              </Button>
                            </td>
                            <td>
                              {atividade.classe_id == id ? (
                                <span className="badge badge-danger p-2">
                                  <i className="fas fa-check mr-1"></i>
                                  Em Uso
                                </span>
                              ) : (
                                <span className="badge badge-success p-2">
                                  <i className="fas fa-plus mr-1"></i>
                                  Disponível
                                </span>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="btn-group" role="group">
                                {atividade.classe_id != id && (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Selecionar atividade</Tooltip>}
                                  >
                                    <Button
                                      variant="primary"
                                      size="sm"
                                      onClick={() => {
                                        carregarTema(atividade.id);
                                        setAtrelarParaTurma(atividade.id);
                                        /*
                                          O vínculo nasce com o modo da atividade. Sem isto o
                                          modal abria sempre em "humano" e o envio sobrescrevia
                                          a herança — uma atividade IA + Humano entrava na turma
                                          como Humano.
                                        */
                                        setModoCorrecaoTurma(atividade.modo_correcao_tema || "humano");
                                        setModoCorrecaoTema(atividade.modo_correcao_tema || "humano");
                                        setShowAdd(true);
                                      }}
                                    >
                                      <i className="fas fa-plus"></i>
                                    </Button>
                                  </OverlayTrigger>
                                )}
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>Editar atividade</Tooltip>}
                                >
                                  <Button
                                    variant="info"
                                    size="sm"
                                    onClick={() => {
                                      carregarTema(atividade.id);
                                      // cada modo com o SEU valor atual, sem misturar
                                      setIdAtividadeRedacao(atividade.id_atividade);
                                      setModoCorrecaoTema(atividade.modo_correcao_tema || "humano");
                                      setModoCorrecaoTurma(atividade.modo_correcao || "humano");
                                      setShowEdit(true);
                                    }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </Button>
                                </OverlayTrigger>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Paginação */}
                {totalPages > 1 && (
                  <div className="border-top p-4">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="text-muted">
                        <i className="fas fa-info-circle mr-2"></i>
                        Mostrando {atividades.length} de {totalItems} atividades
                      </div>
                      <nav aria-label="Navegação de páginas">
                        <ul className="pagination pagination-sm mb-0">
                          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button
                              className="page-link"
                              onClick={paginaAnterior}
                              disabled={currentPage === 1}
                            >
                              <i className="fas fa-chevron-left"></i>
                            </button>
                          </li>
                          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                            let pageNumber;
                            if (totalPages <= 5) {
                              pageNumber = i + 1;
                            } else if (currentPage <= 3) {
                              pageNumber = i + 1;
                            } else if (currentPage >= totalPages - 2) {
                              pageNumber = totalPages - 4 + i;
                            } else {
                              pageNumber = currentPage - 2 + i;
                            }
                            return (
                              <li
                                key={pageNumber}
                                className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => irParaPagina(pageNumber)}
                                >
                                  {pageNumber}
                                </button>
                              </li>
                            );
                          })}
                          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <button
                              className="page-link"
                              onClick={proximaPagina}
                              disabled={currentPage === totalPages}
                            >
                              <i className="fas fa-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>

      {/* Modal para adicionar atividade */}
      <Modal size="lg" show={showAdd} onHide={handleCloseAdd}>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-plus text-success mr-2"></i>
            Adicionar Atividade
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {atrelarParaTurma ? (
            <>
              <div className="alert alert-info">
                <i className="fas fa-info-circle mr-2"></i>
                Deseja aplicar esta atividade para a turma <strong>{turma}</strong>?
              </div>
              {!entrega ? (
                <div className="text-center">
                  <Button
                    variant="success"
                    className="mr-3"
                    onClick={() => setEntrega(true)}
                  >
                    <i className="fas fa-check mr-1"></i>
                    Sim
                  </Button>
                  <Button
                    variant="danger"
                    onClick={handleCloseAdd}
                  >
                    <i className="fas fa-times mr-1"></i>
                    Não
                  </Button>
                </div>
              ) : (
                <Form>
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="font-weight-bold">
                          <i className="fas fa-calendar mr-1"></i>
                          Data de Entrega *
                        </Form.Label>
                        <InputMask
                          className="form-control"
                          placeholder="DD/MM/AAAA"
                          mask="99/99/9999"
                          maskChar={null}
                          value={dataEntrega}
                          onChange={(e) => setDataEntrega(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="font-weight-bold">
                          <i className="fas fa-clock mr-1"></i>
                          Hora de Entrega *
                        </Form.Label>
                        <InputMask
                          className="form-control"
                          placeholder="HH:MM"
                          mask="99:99"
                          maskChar={null}
                          value={horaEntrega}
                          onChange={(e) => setHoraEntrega(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="text-right">
                    <Button
                      variant="secondary"
                      className="mr-2"
                      onClick={handleCloseAdd}
                    >
                      <i className="fas fa-times mr-1"></i>
                      Cancelar
                    </Button>
                    <Button
                      variant="success"
                      onClick={adicionarAtividadeTurma}
                    >
                      <i className="fas fa-check mr-1"></i>
                      Finalizar
                    </Button>
                  </div>
                </Form>
              )}
            </>
          ) : (
            <Form>
              <div className="alert alert-warning">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                Certifique-se de que a atividade não existe com nome similar para evitar duplicações.
              </div>
              
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="font-weight-bold">
                      <i className="fas fa-book mr-1"></i>
                      Nome da Atividade *
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Digite o nome da atividade"
                      value={nomeAtividade}
                      onChange={(e) => setNomeAtividade(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="font-weight-bold">
                      <i className="fas fa-chalkboard-teacher mr-1"></i>
                      Número da Aula *
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Digite o número da aula"
                      value={numeroAula}
                      onChange={(e) => setNumeroAula(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group>
                <Form.Label className="font-weight-bold">
                  <i className="fas fa-tag mr-1"></i>
                  Tipo da Atividade *
                </Form.Label>
                <Form.Control
                  as="select"
                  value={generoAtividade}
                  onChange={(e) => setGeneroAtividade(e.target.value)}
                  required
                >
                  <option value="">Selecione o tipo da atividade</option>
                  <option value="Tema">Tema</option>
                  <option value="Tema Bônus">Tema Bônus</option>
                  <option value="Simulado">Simulado</option>
                </Form.Control>
              </Form.Group>

              {/*
                Ao criar/atrelar, um campo só: ele define o modo da atividade e o
                da turma que a está recebendo. Separá-los só faz sentido na edição,
                quando já existem os dois e podem divergir.
              */}
              <Form.Group>
                <Form.Label className="font-weight-bold">
                  <i className="fas fa-robot mr-1"></i>
                  Modo de Correção *
                </Form.Label>
                <Form.Control
                  as="select"
                  value={modoCorrecaoTema}
                  onChange={(e) => {
                    setModoCorrecaoTema(e.target.value);
                    setModoCorrecaoTurma(e.target.value);
                  }}
                  required
                >
                  <option value="humano">Humano (padrão)</option>
                  <option value="ia_humano">IA + Humano</option>
                </Form.Control>
                <small className="form-text text-muted">
                  Vale para a atividade e para a turma que a receber agora. Depois, cada
                  turma pode ter o seu, editando a atividade.
                  {modoCorrecaoTema === "ia_humano" && (
                    <> A IA corrige primeiro e o corretor revisa antes de liberar para o aluno;
                    estas redações aparecem em <strong>Correção IA + Humano</strong>, não em
                    Redações, e o nome da atividade é enviado à IA como tema.</>
                  )}
                </small>
              </Form.Group>

              <Form.Group>
                <Form.Label className="font-weight-bold">
                  <i className="fas fa-file mr-1"></i>
                  Material de Apoio (Arquivo)
                </Form.Label>
                <Form.File
                  name="arquivo"
                  onChange={sendFile}
                  accept=".pdf,.doc,.docx,.txt"
                />
                {link && (
                  <small className="text-success">
                    <i className="fas fa-check mr-1"></i>
                    Arquivo enviado com sucesso!
                  </small>
                )}
              </Form.Group>

              <Form.Group>
                <Form.Label className="font-weight-bold">
                  <i className="fas fa-comment mr-1"></i>
                  Observações
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Descreva informações úteis para a atividade"
                  value={observacaoAtividade}
                  onChange={(e) => setObservacaoAtividade(e.target.value)}
                />
              </Form.Group>

              <div className="text-right">
                <Button
                  variant="secondary"
                  className="mr-2"
                  onClick={handleCloseAdd}
                >
                  <i className="fas fa-times mr-1"></i>
                  Cancelar
                </Button>
                <Button
                  variant="success"
                  onClick={cadastrarAtividade}
                >
                  <i className="fas fa-plus mr-1"></i>
                  Cadastrar
                </Button>
              </div>
            </Form>
          )}
        </Modal.Body>
      </Modal>

      {/* Modal para editar atividade */}
      <Modal size="lg" show={showEdit} onHide={handleCloseEdit}>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-edit text-info mr-2"></i>
            Editar Atividade
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="alert alert-info">
            <i className="fas fa-info-circle mr-2"></i>
            A edição será aplicada automaticamente para todas as turmas que possuem esta atividade.
          </div>
          
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="font-weight-bold">
                    <i className="fas fa-book mr-1"></i>
                    Nome da Atividade *
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o nome da atividade"
                    value={nomeAtividade}
                    onChange={(e) => setNomeAtividade(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="font-weight-bold">
                    <i className="fas fa-chalkboard-teacher mr-1"></i>
                    Número da Aula *
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o número da aula"
                    value={numeroAula}
                    onChange={(e) => setNumeroAula(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group>
              <Form.Label className="font-weight-bold">
                <i className="fas fa-tag mr-1"></i>
                Tipo da Atividade *
              </Form.Label>
              <Form.Control
                as="select"
                value={generoAtividade}
                onChange={(e) => setGeneroAtividade(e.target.value)}
                required
              >
                <option value="">Selecione o tipo da atividade</option>
                <option value="Tema">Tema</option>
                <option value="Tema Bônus">Tema Bônus</option>
                <option value="Simulado">Simulado</option>
              </Form.Control>
            </Form.Group>

            {/*
              Sempre visível, mesmo sem vínculo com a turma, para o corretor nunca
              ficar sem saber qual é o modo. O padrão é "humano", igual ao da coluna
              no banco. Ao contrário dos demais campos deste modal, ele NÃO se aplica
              às outras turmas: o modo é do vínculo turma↔atividade.
            */}
            {/*
              Dois campos separados, cada um no seu destino, porque são valores
              independentes e podem divergir. Um campo só obrigava a adivinhar o
              alcance da mudança — e antes ela ia para os dois de uma vez.
            */}
            <div className="border rounded p-3 mb-3">
              <div className="font-weight-bold text-dark mb-1">
                <i className="fas fa-robot mr-1"></i>
                Modo de Correção
              </div>
              <small className="text-muted d-block mb-3">
                Escolha o que quer alterar. Os dois são independentes.
              </small>

              {idAtividadeRedacao ? (
                <Form.Group>
                  <Form.Label className="font-weight-bold">
                    Somente nesta turma ({turma})
                  </Form.Label>
                  <Form.Control
                    as="select"
                    value={modoCorrecaoTurma}
                    onChange={(e) => setModoCorrecaoTurma(e.target.value)}
                    required
                  >
                    <option value="humano">Humano</option>
                    <option value="ia_humano">IA + Humano</option>
                  </Form.Control>
                  <small className="form-text text-muted">
                    Vale só aqui. As outras turmas que têm esta atividade não são afetadas.
                  </small>
                </Form.Group>
              ) : (
                <div className="alert alert-secondary py-2 mb-3" style={{ fontSize: "13px" }}>
                  Esta atividade ainda não está nesta turma, então só existe o modo da
                  atividade abaixo. Ele será herdado quando ela for adicionada.
                </div>
              )}

              <Form.Group className="mb-0">
                <Form.Label className="font-weight-bold">
                  Da atividade em si (padrão)
                </Form.Label>
                <Form.Control
                  as="select"
                  value={modoCorrecaoTema}
                  onChange={(e) => setModoCorrecaoTema(e.target.value)}
                  required
                >
                  <option value="humano">Humano</option>
                  <option value="ia_humano">IA + Humano</option>
                </Form.Control>
                <small className="form-text text-muted">
                  É o padrão da atividade, herdado pelas turmas que a receberem daqui em
                  diante. Não muda as turmas que já a possuem.
                </small>
              </Form.Group>

              {(modoCorrecaoTurma === "ia_humano" || modoCorrecaoTema === "ia_humano") && (
                <small className="form-text text-muted mt-2">
                  Em IA + Humano as redações aparecem em <strong>Correção IA + Humano</strong>,
                  não em Redações, e o nome da atividade é enviado à IA como tema.
                </small>
              )}
            </div>

            <Form.Group>
              <Form.Label className="font-weight-bold">
                <i className="fas fa-file mr-1"></i>
                Material de Apoio (Arquivo)
              </Form.Label>
              <Form.File
                name="arquivo"
                onChange={sendFile}
                accept=".pdf,.doc,.docx,.txt"
              />
              {link && (
                <small className="text-success">
                  <i className="fas fa-check mr-1"></i>
                  Arquivo atualizado com sucesso!
                </small>
              )}
            </Form.Group>

            <Form.Group>
              <Form.Label className="font-weight-bold">
                <i className="fas fa-comment mr-1"></i>
                Observações
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Descreva informações úteis para a atividade"
                value={observacaoAtividade}
                onChange={(e) => setObservacaoAtividade(e.target.value)}
              />
            </Form.Group>

            <div className="text-right">
              <Button
                variant="secondary"
                className="mr-2"
                onClick={handleCloseEdit}
              >
                <i className="fas fa-times mr-1"></i>
                Cancelar
              </Button>
              <Button
                variant="info"
                onClick={editarAtividade}
              >
                <i className="fas fa-save mr-1"></i>
                Salvar Alterações
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal para editar data */}
      <Modal show={showEditDate} onHide={handleCloseEditDate}>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-calendar text-warning mr-2"></i>
            Editar Data de Entrega
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="alert alert-warning">
            <i className="fas fa-exclamation-triangle mr-2"></i>
            Esta alteração será aplicada APENAS nesta turma.
          </div>
          
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="font-weight-bold">
                    <i className="fas fa-calendar mr-1"></i>
                    Nova Data de Entrega *
                  </Form.Label>
                  <InputMask
                    className="form-control"
                    placeholder="DD/MM/AAAA"
                    mask="99/99/9999"
                    maskChar={null}
                    value={dataEntrega}
                    onChange={(e) => setDataEntrega(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="font-weight-bold">
                    <i className="fas fa-clock mr-1"></i>
                    Nova Hora de Entrega *
                  </Form.Label>
                  <InputMask
                    className="form-control"
                    placeholder="HH:MM"
                    mask="99:99"
                    maskChar={null}
                    value={horaEntrega}
                    onChange={(e) => setHoraEntrega(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="text-right">
              <Button
                variant="secondary"
                className="mr-2"
                onClick={handleCloseEditDate}
              >
                <i className="fas fa-times mr-1"></i>
                Cancelar
              </Button>
              <Button
                variant="warning"
                onClick={editarDataAtividade}
              >
                <i className="fas fa-save mr-1"></i>
                Salvar Data
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal para visualizar material */}
      <Modal show={showMaterial} onHide={handleCloseMaterial}>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-file-alt text-info mr-2"></i>
            Material de Apoio
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {arquivo && (
            <div className="mb-3">
              <h6 className="font-weight-bold">
                <i className="fas fa-download mr-1"></i>
                Arquivo:
              </h6>
              <a
                href={arquivo.startsWith('/') ? `https://redacoes.nyc3.digitaloceanspaces.com${arquivo}` : arquivo}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-primary btn-sm"
              >
                <i className="fas fa-external-link-alt mr-1"></i>
                Abrir Arquivo
              </a>
            </div>
          )}
          
          {descricao && (
            <div>
              <h6 className="font-weight-bold">
                <i className="fas fa-comment mr-1"></i>
                Descrição:
              </h6>
              <div className="bg-light p-3 rounded">
                {descricao}
              </div>
            </div>
          )}
          
          {!arquivo && !descricao && (
            <div className="text-center text-muted">
              <i className="fas fa-inbox fa-3x mb-3"></i>
              <p>Nenhum material de apoio disponível para esta atividade.</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseMaterial}>
            <i className="fas fa-times mr-1"></i>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para seleção múltipla de temas */}
      <Modal show={showBulkAdd} onHide={handleCloseBulkAdd} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-list-check text-primary mr-2"></i>
            Selecionar Temas para Vincular
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="alert alert-info">
            <i className="fas fa-info-circle mr-2"></i>
            Selecione os temas que deseja vincular à turma e defina a data e hora limite.
          </div>

          {/* Campos de data e hora limite */}
          <Row className="mb-4">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="font-weight-bold">
                  <i className="fas fa-calendar mr-1"></i>
                  Data Limite *
                </Form.Label>
                <InputMask
                  className="form-control"
                  placeholder="DD/MM/AAAA"
                  mask="99/99/9999"
                  maskChar={null}
                  value={dataLimite}
                  onChange={(e) => setDataLimite(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="font-weight-bold">
                  <i className="fas fa-clock mr-1"></i>
                  Hora Limite *
                </Form.Label>
                <InputMask
                  className="form-control"
                  placeholder="HH:MM"
                  mask="99:99"
                  maskChar={null}
                  value={horaLimite}
                  onChange={(e) => setHoraLimite(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Filtros do modal */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group className="position-relative">
                <Form.Label className="font-weight-bold text-dark">
                  <i className="fas fa-search text-primary mr-1"></i>
                  Buscar por Nome
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Digite o nome da atividade"
                    value={modalBuscaNome}
                    onChange={(e) => {
                      handleModalBuscaNomeChange(e);
                      setModalCurrentPage(1);
                    }}
                    onFocus={() => gerarSugestoesModal(modalBuscaNome)}
                    onBlur={() => setTimeout(() => setModalShowDropdown(false), 200)}
                    className="form-control-lg"
                  />
                  <InputGroup.Append>
                    <InputGroup.Text>
                      <i className="fas fa-search"></i>
                    </InputGroup.Text>
                  </InputGroup.Append>
                </InputGroup>
                {modalShowDropdown && modalFilteredSuggestions.length > 0 && (
                  <div 
                    className="position-absolute w-100 border border-top-0 rounded-bottom shadow-sm" 
                    style={{ 
                      zIndex: 1000, 
                      maxHeight: '200px', 
                      overflowY: 'auto', 
                      top: '100%',
                      backgroundColor: '#ffffff',
                      opacity: 1
                    }}
                  >
                    {modalFilteredSuggestions.map((sugestao, index) => (
                       <div
                         key={index}
                         className="p-2 border-bottom text-dark"
                         style={{ 
                           cursor: 'pointer', 
                           color: '#333',
                           backgroundColor: '#ffffff',
                           opacity: 1
                         }}
                         onMouseDown={() => {
                           setModalBuscaNome(sugestao);
                           setModalShowDropdown(false);
                           setModalCurrentPage(1);
                         }}
                         onMouseEnter={(e) => {
                           e.target.style.backgroundColor = '#f8f9fa';
                           e.target.style.color = '#333';
                           e.target.style.opacity = '1';
                         }}
                         onMouseLeave={(e) => {
                           e.target.style.backgroundColor = '#ffffff';
                           e.target.style.color = '#333';
                           e.target.style.opacity = '1';
                         }}
                       >
                         <i className="fas fa-file-alt mr-2 text-muted"></i>
                         <span style={{ color: '#333' }}>{sugestao}</span>
                       </div>
                     ))}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="font-weight-bold text-dark">
                  <i className="fas fa-tag text-primary mr-1"></i>
                  Filtrar por Tipo
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    as="select"
                    value={modalFiltroTipo}
                    onChange={(e) => {
                      setModalFiltroTipo(e.target.value);
                      setModalCurrentPage(1);
                    }}
                    className="form-control-lg"
                  >
                    <option value="">Todos os Tipos</option>
                    <option value="Tema">Tema</option>
                    <option value="Tema Bônus">Tema Bônus</option>
                    <option value="Simulado">Simulado</option>
                  </Form.Control>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Label className="font-weight-bold d-block">&nbsp;</Form.Label>
              <Button
                variant="outline-secondary"
                onClick={limparFiltrosModal}
                className="w-100"
                title="Limpar filtros"
              >
                <i className="fas fa-times"></i>
              </Button>
            </Col>
          </Row>

          {/* Lista de atividades para seleção */}
          <div className="mb-3">
            <h6 className="font-weight-bold">
              <i className="fas fa-tasks mr-1"></i>
              Temas Disponíveis ({selectedAtividades.length} selecionados)
            </h6>
          </div>

          <div style={{ minHeight: '300px' }}>
             {(() => {
               const { atividades: modalAtividades, totalPaginas, totalItens } = getModalAtividades();
               
               return (
                 <>
                   {modalAtividades.map((atividade) => {
                     const isSelected = selectedAtividades.some(item => item.id === atividade.id);
                     const isInUse = atividade.classe_id == id; // Verifica se já está em uso na turma
                     
                     return (
                       <div
                         key={atividade.id}
                         className={`border rounded p-3 mb-2 ${
                           isInUse 
                             ? 'border-warning bg-warning-light' 
                             : isSelected 
                               ? 'bg-primary text-white border-primary' 
                               : 'bg-light border-secondary'
                         }`}
                         onClick={() => !isInUse && toggleAtividadeSelection(atividade)}
                         style={{ 
                           cursor: isInUse ? 'not-allowed' : 'pointer',
                           opacity: isInUse ? 0.7 : 1
                         }}
                       >
                         <div className="d-flex justify-content-between align-items-center">
                           <div style={{ flex: 1, minWidth: 0 }}>
                             <h6 className="mb-1" style={{ wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto' }}>
                               {isInUse ? (
                                 <>
                                   <i className="fas fa-exclamation-triangle mr-2 text-warning"></i>
                                   {atividade.nome}
                                 </>
                               ) : (
                                 <>
                                   <i className={`fas fa-${isSelected ? 'check-square' : 'square'} mr-2`}></i>
                                   {atividade.nome}
                                 </>
                               )}
                             </h6>
                             <small className={isInUse ? 'text-warning font-weight-bold' : isSelected ? 'text-light' : 'text-muted'}>
                               {isInUse ? (
                                 <>
                                   <i className="fas fa-check-circle mr-1"></i>
                                   EM USO - Gênero: {atividade.genero}
                                 </>
                               ) : (
                                 `Gênero: ${atividade.genero}`
                               )}
                             </small>
                           </div>
                           {isInUse && (
                             <div className="text-warning">
                               <i className="fas fa-lock fa-lg"></i>
                             </div>
                           )}
                         </div>
                       </div>
                     );
                   })}
                   
                   {/* Paginação do Modal */}
                   {totalPaginas > 1 && (
                     <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                       <div className="text-muted small">
                         Mostrando {((modalCurrentPage - 1) * modalItemsPerPage) + 1} a {Math.min(modalCurrentPage * modalItemsPerPage, totalItens)} de {totalItens} temas
                       </div>
                       <div className="d-flex align-items-center">
                         <Button
                           variant="outline-secondary"
                           size="sm"
                           onClick={() => setModalCurrentPage(prev => Math.max(prev - 1, 1))}
                           disabled={modalCurrentPage === 1}
                           className="mr-2"
                         >
                           <i className="fas fa-chevron-left"></i>
                         </Button>
                         
                         <span className="mx-3 small">
                           Página {modalCurrentPage} de {totalPaginas}
                         </span>
                         
                         <Button
                           variant="outline-secondary"
                           size="sm"
                           onClick={() => setModalCurrentPage(prev => Math.min(prev + 1, totalPaginas))}
                           disabled={modalCurrentPage === totalPaginas}
                           className="ml-2"
                         >
                           <i className="fas fa-chevron-right"></i>
                         </Button>
                       </div>
                     </div>
                   )}
                   
                   {totalItens === 0 && (
                     <div className="text-center text-muted py-4">
                       <i className="fas fa-inbox fa-3x mb-3"></i>
                       <p>Nenhum tema disponível para seleção.</p>
                     </div>
                   )}
                 </>
               );
             })()}
           </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseBulkAdd}>
            <i className="fas fa-times mr-1"></i>
            Cancelar
          </Button>
          <Button 
            variant="primary" 
            onClick={enviarLoteAtividades}
            disabled={selectedAtividades.length === 0 || !dataLimite || !horaLimite}
          >
            <i className="fas fa-paper-plane mr-1"></i>
            Vincular {selectedAtividades.length} Tema(s)
          </Button>
        </Modal.Footer>
      </Modal>
    </Template>
  );
}

export default Atividades;
